import * as React from "react";
import Integrations from "../integrations/integrations";
import Title from "../title/title";
import "./block-integrations.scss";

interface IIntegrationsBlockProps {
  readonly isPrice?: boolean;
}

class BlockIntegrations extends React.Component<IIntegrationsBlockProps, {}> {
  public render() {
    return (
      <div className="block-integrations">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Title
                title="Bizy works with 
Email, Slack, and Trello"
                extraClasses="block__heading--small"
                small
                isPrice
              />
              <Integrations />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BlockIntegrations;



// WEBPACK FOOTER //
// ./src/components/block-integrations/block-integrations.tsx